/**
 * Simple demo pages for UI Harness
 * 
 * These show layout structure with placeholder content
 */

export function HarnessDemoPage({ title, description }) {
  return (
    <div className="p-6">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-2xl font-semibold text-gray-900 mb-1">{title}</h1>
        <p className="text-sm text-gray-600 mb-6">{description}</p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          {[1, 2, 3].map((i) => (
            <div key={i} className="bg-white rounded-lg shadow-sm p-5 border border-gray-100 hover:shadow-md transition-shadow">
              <div className="w-10 h-10 bg-gradient-to-br from-orange-400 to-pink-500 rounded-md mb-3"></div>
              <h3 className="font-semibold text-sm text-gray-900 mb-1">Card {i}</h3>
              <p className="text-xs text-gray-600">
                Compact card with refined spacing and subtle shadows.
              </p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100">
          <h2 className="text-lg font-semibold text-gray-900 mb-3">Content Area</h2>
          <p className="text-sm text-gray-600 mb-3">
            This section demonstrates the refined CloudWaitress-inspired layout with tighter spacing
            and improved information density.
          </p>
          
          <div className="bg-gray-50 rounded-md p-4 border border-gray-200">
            <h3 className="font-semibold text-sm text-gray-700 mb-2">Mock Data Info</h3>
            <ul className="text-xs text-gray-600 space-y-1">
              <li>• User: Test User (owner@testbusiness.com)</li>
              <li>• Business: Test Restaurant</li>
              <li>• SMS Balance: 425 credits</li>
              <li>• Wallet: $12.50 AUD</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
